<div class="row col-12 p-0 m-0 main-page-section ">
  <!-- <div class="p-0">
            <app-side-nav [item]="meetingNav"></app-side-nav>
        </div> -->
  <div class="col-12 p-0 employee-section">
    <!-- <app-header></app-header> -->
    <div class="col-height">

      <div>

        <div class="breadcrumbs-section padding-left">
          <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
          <img src="../../assets/images/seperator.png">
          <span class="curr-page pl-2 breadcrumbs-section-font current">Bulk Invite</span>
        </div>

        <div class="invite-layout">

          <div class="row" style="align-items: flex-end;">
            <h1 class="col-10">Bulk Invite</h1>

            <button class="button-invite col-2" routerLink="/vms/bulk-invite/invite">Invite</button>
          </div>

          <div class="row mt-4">
            <p class="col-12">{{member?.length}} upcoming meetings</p>
          </div>

          <div *ngFor="let item of member|slice:member.length-5">
            <div class="row meeting-row mt-2 ml-0 ">
              <div class="col-1 date">
                <p>{{formatDate(item?.mstart,'date')}}</p>
                <p class="month">{{formatDate(item?.mstart,'month')}}</p>
              </div>
              <div (click)="navigateToDetail(item?.t0600Vmsguests[0]?.invitationId)" class="col-8 pl-4 pt-1">
                <div style="display: flex;" >
                <p class="name" *ngFor="let name of item?.t0600Vmsguests|slice:item?.t0600Vmsguests?.length-2;let i=index;">{{name?.fullName}}<span >,</span></p><span *ngIf="item?.t0600Vmsguests?.length>2">+ {{item?.t0600Vmsguests?.length-2}} more</span>
              </div>
                <p class="detail">Booked on {{formatDate(item?.createdDate,'format')}}</p>
              </div>
              <div *ngIf="itam?.approvalDate==null" class="col-2 orange-text pt-4" >Approval Awaited</div>

              <div class="col-1">

                <div class="list-option pt-4" [id]="i+'__faq__'+item?.t0600Vmsguests[0]?.invitationId"
                  (click)="$event.stopPropagation();openDrawer(i+'__faq__'+item.t0600Vmsguests[0]?.invitationId,item)">
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="drawer-container">
                    <div>
                      <p (click)="cancelInvite(item.t0600Vmsguests[0]?.invitationId)">Cancel Meeting</p>
                      <p (click)="approvalRemainder(item.t0600Vmsguests[0]?.invitationId)">Send a remainder to CapitaLand</p>

                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <hr class="ml-0">

          <div class="row">
            <div class="col-12">
              <h2>History</h2>
            </div>
          </div>

          <div class="row meeting-row mt-2 ml-0 " *ngFor="let item of history|slice:history?.length-5">
            <div class="col-1 date">
              <p>{{formatDate(item.mstart,'date')}}</p>
                <p class="month">{{formatDate(item.mstart,'month')}}</p>
            </div>
            <div (click)="navigateToDetail(item?.t0600Vmsguests[0]?.invitationId)" class="col-8 pl-4 pt-1">
              <div style="display: flex;" >
              <p class="name" *ngFor="let name of item?.t0600Vmsguests|slice:item?.t0600Vmsguests?.length-2"  >{{name?.fullName}}<span >,</span></p><span *ngIf="item?.t0600Vmsguests?.length>2">+ {{item?.t0600Vmsguests?.length-2}} more</span>
            </div>
              <p class="detail">Booked on {{formatDate(item?.createdDate,'format')}}</p>
            </div>
            <div class="col-1"></div>
            <div class="col-2 align-right">
              <button (click)="reInvite(item?.t0600Vmsguests[0]?.invitationId)">Re-Invite</button>
            </div>
          </div>

          <div class="row">
            <div class="col-12 align-right">
              <button type="submit" (click)="navigateToHistory()">View history for the last 90 days.</button>
            </div>
          </div>


        </div>


      </div>

      <!-- <app-footer></app-footer> -->

    </div>
  </div>
